import queryString from 'query-string'
import { filterQueryParams } from '@/utils'
import { PrescriptionAPI } from './types'
import { base64Encode } from '@/utils'

export const prescriptionApi: PrescriptionAPI = ky => {
  return {
    async fetch({ patientId, year }) {
      const params = filterQueryParams({ year })

      return ky(`patient/${patientId}/prescription/`, {
        method: 'get',
        searchParams: queryString.stringify(params)
      }).json()
    },

    async uploadQR({ patientId, data }) {
      return await ky(`patient/${patientId}/prescription/qrcode/`, {
        method: 'post',
        body: JSON.stringify({ data: await base64Encode(data) })
      }).json()
    }
  }
}
